import { useId, type ReactNode } from 'react'

/** Independent feed sections also give future daylists a natural place on Home. */
export function HomeSection({ title, subtitle, action, children }: {
  title: string
  subtitle?: string
  action?: ReactNode
  children: ReactNode
}) {
  const id = useId()
  return (
    <section aria-labelledby={id} className="min-w-0">
      <header className="mb-4 flex items-center justify-between gap-3">
        <div className="min-w-0">
          <h2 id={id} className="text-lg font-semibold tracking-tight text-text">{title}</h2>
          {subtitle ? <p className="mt-1 text-sm text-text-muted">{subtitle}</p> : null}
        </div>
        {action}
      </header>
      {children}
    </section>
  )
}
